import React, { useState, useEffect } from 'react';
import styled from 'styled-components';
import { SketchPicker } from 'react-color';
import { TextField, Button, Modal, Box } from '@mui/material';
import LoadingOverlay from '../../mui/LoadingOverlay';
import { toast } from 'react-toastify';
import { useDispatch } from 'react-redux';
import { updategroups } from '../../redux/businessSlice';
import { useUpdateGroupMutation } from '../../redux/organizationApi';
const UpdateBusinessGroup = ({ open, onClose, group }) => {
  const [businessNature, setBusinessNature] = useState(group?.businessNature || '');
  const [businessColor, setBusinessColor] = useState(group?.businessColor || '#fff');
  const [isColorPickerOpen, setIsColorPickerOpen] = useState(false);
  const [loading, setLoading] = useState(false);
  const dispatch = useDispatch();
  const [updateGroupMutation] = useUpdateGroupMutation();
  useEffect(() => {
    setBusinessNature(group?.businessNature || '');
    setBusinessColor(group?.businessColor || '#fff');
  }, [group]);

  const handleColorChange = (color) => {
    setBusinessColor(color.hex);
  };

  const handleColorBoxClick = () => {
    setIsColorPickerOpen(!isColorPickerOpen);
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    const updatedGroup = {
      ...group,
      businessNature,
      businessColor,
    };

    try {
      const response = await updateGroupMutation({
        id: group._id,
        data: updatedGroup,
      }).unwrap();
      if (response?.group) {
        dispatch(updategroups(response.group));
      }
      toast.success("Business Group updated successfully");
      onClose();
    } catch (error) {
      toast.error(
        error?.data?.message || error?.error || "Failed to update business group"
      );
    } finally {
      setLoading(false);
    }
  };

  return (
    <Modal open={open} onClose={onClose}>
      <Box sx={modalStyle}>
        <FormContainer>
          <FormTitle>Update Business Group</FormTitle>
          <form onSubmit={handleSubmit}>
            <FormField>
              <TextField
                size="small"
                label="Business Nature"
                variant="outlined"
                fullWidth
                inputProps={{
    style: { textTransform: 'capitalize' },
  }}
                value={businessNature}
                onChange={(e) => setBusinessNature(e.target.value)}
                required
              />
            </FormField>
            <FormField>
              <Label>Business Color</Label>
              <ColorPickerContainer>
                <ColorBox color={businessColor} onClick={handleColorBoxClick} />
                {isColorPickerOpen && (
                  <SketchPicker
                    color={businessColor}
                    onChange={handleColorChange}
                  />
                )}
              </ColorPickerContainer>
            </FormField>
            <SubmitButton type="submit" variant="contained" color="primary">
              Update Business Group
            </SubmitButton>
          </form>
          {loading && <LoadingOverlay open={loading} />}
        </FormContainer>
      </Box>
    </Modal>
  );
};

export default UpdateBusinessGroup;

const modalStyle = {
  position: 'absolute',
  top: '50%',
  left: '50%',
  transform: 'translate(-50%, -50%)',
  width: "45%",
  bgcolor: 'background.paper',
  boxShadow: 24,
  p: 4,
  borderRadius: 2,
};

const FormContainer = styled.div`
  padding: 20px;
  background: #fdfdfd;
  border-radius: 8px;
`;

const FormTitle = styled.h4`
  text-align: center;
  margin-bottom: 20px;
  color: #333;
  font-family: 'Roboto', sans-serif;
`;

const FormField = styled.div`
  margin-bottom: 20px;
`;

const Label = styled.label`
  display: block;
  margin-bottom: 8px;
  font-weight: bold;
  color: #333;
`;

const ColorPickerContainer = styled.div`
  display: flex;
  align-items: center;
  position: relative;
`;

const ColorBox = styled.div`
  width: 40px;
  height: 40px;
  background-color: ${(props) => props.color};
  border: 1px solid #ccc;
  border-radius: 4px;
  cursor: pointer;
  margin-right: 15px;
`;

const SubmitButton = styled(Button)`
  width: 100%;
  padding: 10px;
  font-size: 14px;
  font-weight: bold;
  text-transform: uppercase;
`;
